import React, { useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt as editIcon } from '@fortawesome/free-solid-svg-icons';
import { TaskProps } from '../helpers/types';

/*
  Components
*/
import TaskEdit from './TaskEdit';

/* eslint-disable react/jsx-props-no-spreading */
const Task = ({ task, index, handleUpdateTask }: TaskProps) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      {isEditing && (
        <TaskEdit
          task={task}
          handleUpdateTask={handleUpdateTask}
          setState={setIsEditing} />
      )}
      <Draggable draggableId={task.id} index={index}>
        {(provided: any, snapshot: any) => (
          <div className={`task__container ${snapshot.isDragging ? 'dragging' : ''}`} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} data-is-dragging={snapshot.isDragging}>
            <div className="task">
              <div className="drag-n-drop">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <h2 className="task__title">{task.taskTitle}</h2>
            </div>
            <button type="button" onClick={() => setIsEditing(true)}>
              <FontAwesomeIcon className="task__edit" icon={editIcon} />
            </button>
          </div>
        )}
      </Draggable>
    </>
  );
};

export default Task;
